import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	unknownUserName: {
		id: 'platform-opsgenie-schedule.services.unknown-user-name',
		defaultMessage: 'Unknown user',
		description: 'User name to display on on-call schedule when name cannot be determined',
	},
});

export default messages;
